/* ======== Utils ======== */
export const $ = (s, p = document) => p.querySelector(s)
export const $$ = (s, p = document) => [...p.querySelectorAll(s)]
export const shuffled = (a) => [...a].sort(() => Math.random() - 0.5)

export function el(tag, attrs = {}, ...children) {
	const n = document.createElement(tag)
	for (const [k, v] of Object.entries(attrs)) {
		if (k === 'dataset') {
			for (const [dk, dv] of Object.entries(v)) n.dataset[dk] = dv
		} else if (k.startsWith('on')) n.addEventListener(k.slice(2), v)
		else if (v != null) n.setAttribute(k, v)
	}
	for (const c of children)
		n.append(typeof c === 'string' ? document.createTextNode(c) : c)
	return n
}

export function lineSelected() {
	document.dispatchEvent(
		new CustomEvent('ligne-selected', {
			detail: {},
			bubbles: true, // pour que l'événement remonte dans le DOM
		})
	)
}
